import {ParsedUrlQuery} from 'querystring';
import {convertQueryInputToSingleElement} from '../../common/shared/utils/convertQueryInputToSingleElement';

export function getRankingParamFromQuery({
  uidInfoList,
  query,
}: {
  uidInfoList: string[];
  query?: ParsedUrlQuery;
}) {
  const [category_uid, subcategory_uid] = uidInfoList;
  const categoryUid = convertQueryInputToSingleElement(category_uid);
  const subcategoryUid = convertQueryInputToSingleElement(subcategory_uid);
  const rankingType = convertQueryInputToSingleElement(query?.ranking_type);

  return {
    categoryUid: Number(categoryUid),
    subcategoryUid,
    rankingType,
  };
}
